import React, { FunctionComponent } from 'react';

interface Props {
  value: string;
  onChange: (property: string, val: string) => void;
  property: string;
}

export const TestDriveRange: FunctionComponent<Props> = ({
  value,
  onChange,
  property,
}) => (
  <div className="input-container input-number-container">
    <label>Will Allow Remote Test Drives Within (Miles)</label>
    <input
      value={value}
      type="number"
      min="0"
      max="1000"
      onChange={(e) => onChange(property, e.target.value)}
    />
  </div>
);
